import { useAbly, useConnectionStateListener } from "ably/react";
import { useState } from "react";

export const useAblyConnectionState = () => {
  const ably = useAbly();
  const [connectionState, setConnectionState] = useState(ably.connection.state);

  useConnectionStateListener((stateChange) => {
    setConnectionState(stateChange.current);
  });

  return connectionState;
};
